<script>
export default {
  props: {
    model: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      columns: [
        {
          dataField: 'tipo_modalidade',
          caption: 'Tipo',
          editorOptions: {
            maxLength: 2
          }
        },
        {
          dataField: 'perc_desconto',
          caption: 'Percentual',
          dataType: 'number',
          editorOptions: {
            format: '#0%',
            step: 0.01
          }
        }
      ]
    }
  }
}
</script>
<template>
  <div>
    <ui-grid-form
      :columns="columns"
      :model="model"
      @change="v => $emit('change', v)"
      mode-edit="form"
      :allow-add="true"
      :allow-del="true"
      :header="true" />
  </div>
</template>
